const renamedFormData = {
  "size": "medium",
  "span": 24,
  "column": 2,
  "fields": [
    {
      "type": "default",
      "align": "top",
      "justify": "start",
      "__config__": {
        "span": 24,
        "formId": "kM1lzLIcv",
        "layout": "rowFormItem",
        "tagIcon": "row",
        "children": [
          {
            "style": {
              "width": "100%"
            },
            "__slot__": {
              "append": "",
              "suffix": "",
              "prepend": ""
            },
            "disabled": false,
            "readonly": false,
            "clearable": true,
            "__config__": {
              "tag": "el-input",
              "_tag": "a-input",
              "span": 24,
              "label": "新用户名",
              "formId": "k1JzjUXq0",
              "layout": "colFormItem",
              "regList": [
                {
                  "message": "请输入正确用户名",
                  "pattern": ""
                }
              ],
              "tagIcon": "input",
              "document": "https://element.eleme.cn/#/zh-CN/component/input",
              "required": true,
              "showItem": true,
              "changeTag": true,
              "renderKey": "k1JzjUXq01637827577533",
              "showLabel": true,
              "renderItem": true
            },
            "__vModel__": "clientName",
            "placeholder": "请输入新用户名",
            "prefix-icon": "",
            "suffix-icon": "",
            "__readonly__": {
              "span": 1
            },
            "show-word-limit": false
          },
          {
            "style": {
              "width": "100%"
            },
            "__slot__": {
              "append": "",
              "suffix": "",
              "prepend": ""
            },
            "disabled": false,
            "readonly": false,
            "clearable": true,
            "__config__": {
              "tag": "el-input",
              "_tag": "a-input",
              "span": 24,
              "label": "新联系人",
              "formId": "ku6A1eMI7",
              "layout": "colFormItem",
              "regList": [
                {
                  "message": "请输入正确联系人",
                  "pattern": "/^[\\u4e00-\\u9fa5]{2,10}$/"
                }
              ],
              "tagIcon": "input",
              "document": "https://element.eleme.cn/#/zh-CN/component/input",
              "required": true,
              "showItem": true,
              "changeTag": true,
              "renderKey": "ku6A1eMI71637827582050",
              "showLabel": true,
              "renderItem": true
            },
            "__vModel__": "contacter",
            "placeholder": "请输入新联系人",
            "prefix-icon": "",
            "suffix-icon": "",
            "__readonly__": {
              "span": 1
            },
            "show-word-limit": false
          },
          {
            "style": {
              "width": "100%"
            },
            "__slot__": {
              "append": "",
              "suffix": "",
              "prepend": ""
            },
            "disabled": false,
            "readonly": false,
            "clearable": true,
            "__config__": {
              "tag": "el-input",
              "_tag": "a-input",
              "span": 24,
              "label": "新手机号",
              "formId": "kRjluj1MG",
              "layout": "colFormItem",
              "regList": [
                {
                  "message": "请输入正确手机号码",
                  "pattern": "/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\\d{8}$/"
                }
              ],
              "tagIcon": "input",
              "document": "https://element.eleme.cn/#/zh-CN/component/input",
              "required": false,
              "showItem": true,
              "changeTag": true,
              "renderKey": "kRjluj1MG1637827586524",
              "showLabel": true,
              "renderItem": true
            },
            "__vModel__": "mobileNew",
            "placeholder": "请输入新手机号",
            "prefix-icon": "",
            "suffix-icon": "",
            "__readonly__": {
              "span": 1
            },
            "show-word-limit": false
          },
          {
            "style": {
              "width": "100%"
            },
            "__slot__": {
              "append": "",
              "suffix": "",
              "prepend": ""
            },
            "disabled": false,
            "readonly": false,
            "clearable": true,
            "__config__": {
              "tag": "el-input",
              "_tag": "a-input",
              "span": 24,
              "label": "身份证号",
              "formId": "kh1hMiV8G",
              "layout": "colFormItem",
              "regList": [
                {
                  "message": "请输入正确的身份证号",
                  "pattern": "/^[1-9]\\d{5}(?:18|19|20)\\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\\d|30|31)\\d{3}[\\dXx]$/"
                }
              ],
              "tagIcon": "input",
              "document": "https://element.eleme.cn/#/zh-CN/component/input",
              "required": false,
              "showItem": true,
              "changeTag": true,
              "renderKey": "kh1hMiV8G1666260426838",
              "showLabel": true,
              "renderItem": true
            },
            "__vModel__": "idNumber",
            "placeholder": "请输入身份证号",
            "prefix-icon": "",
            "suffix-icon": "",
            "__readonly__": {
              "span": 1
            },
            "show-word-limit": false
          },
          {
            "style": {
              "width": "100%"
            },
            "__slot__": {
              "append": "",
              "suffix": "",
              "prepend": ""
            },
            "disabled": false,
            "readonly": false,
            "clearable": true,
            "__config__": {
              "tag": "el-input",
              "_tag": "a-input",
              "span": 24,
              "label": "更名申请原因",
              "formId": "kN0RYAw47",
              "layout": "colFormItem",
              "regList": [],
              "tagIcon": "input",
              "document": "https://element.eleme.cn/#/zh-CN/component/input",
              "required": true,
              "showItem": true,
              "changeTag": true,
              "renderKey": "kN0RYAw471637990883564",
              "showLabel": true,
              "renderItem": true
            },
            "__vModel__": "remark",
            "placeholder": "请输入更名申请原因",
            "prefix-icon": "",
            "suffix-icon": "",
            "__readonly__": {
              "span": 1
            },
            "show-word-limit": false
          },
          {
            "name": "file",
            "accept": "image/*",
            "__slot__": {
              "list-type": true
            },
            "disabled": false,
            "multiple": false,
            "list-type": "text",
            "__config__": {
              "tag": "el-upload",
              "_tag": "a-upload",
              "span": 24,
              "label": "附件上传",
              "formId": "kgmTgiCZ2",
              "layout": "colFormItem",
              "regList": [],
              "tagIcon": "upload",
              "document": "https://element.eleme.cn/#/zh-CN/component/upload",
              "fileSize": 5,
              "required": false,
              "showItem": true,
              "sizeUnit": "MB",
              "changeTag": true,
              "renderKey": "kgmTgiCZ21657508249951",
              "showLabel": true,
              "buttonText": "点击上传",
              "notify": '提示： 需上传房主身份证照片、房产证照片、水表正面照片（有水卡水表需要插卡拍照）、水表侧面照片（包含水表号）',
              "renderItem": true
            },
            "__vModel__": "houseCertificate",
            "buttonText": "",
            "auto-upload": true,
            "placeholder": "请上传附件文件",
            "__readonly__": {
              "span": 2
            },
            "uploadNumber": 5
          }
        ],
        "document": "https://element.eleme.cn/#/zh-CN/component/layout#row-attributes",
        "renderKey": "kM1lzLIcv1637827546906",
        "layoutTree": true,
        "componentName": "row_kM1lzLIcv"
      }
    }
  ],
  "gutter": 15,
  "formRef": "elForm",
  "disabled": false,
  "formBtns": true,
  "readonly": false,
  "formModel": "formData",
  "formRules": "rules",
  "labelWidth": 100,
  "labelPosition": "right"
}

const phoneFormData = {
  "size": "medium",
  "span": 24,
  "column": 2,
  "fields": [
    {
      "type": "default",
      "align": "top",
      "justify": "start",
      "__config__": {
        "span": 24,
        "formId": "kM1lzLIcv",
        "layout": "rowFormItem",
        "tagIcon": "row",
        "children": [
          {
            "style": {
              "width": "100%"
            },
            "__slot__": {
              "append": "",
              "suffix": "",
              "prepend": ""
            },
            "disabled": false,
            "readonly": false,
            "clearable": true,
            "__config__": {
              "tag": "el-input",
              "_tag": "a-input",
              "span": 24,
              "label": "新手机号",
              "formId": "kRjluj1MG",
              "layout": "colFormItem",
              "regList": [
                {
                  "message": "请输入正确手机号码",
                  "pattern": "/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\\d{8}$/"
                }
              ],
              "tagIcon": "input",
              "document": "https://element.eleme.cn/#/zh-CN/component/input",
              "required": false,
              "showItem": true,
              "changeTag": true,
              "renderKey": "kRjluj1MG1637827586524",
              "showLabel": true,
              "renderItem": true
            },
            "__vModel__": "mobileNew",
            "placeholder": "请输入新手机号",
            "prefix-icon": "",
            "suffix-icon": "",
            "__readonly__": {
              "span": 1
            },
            "show-word-limit": false
          },
          {
            "name": "file",
            "accept": "image/*",
            "__slot__": {
              "list-type": true
            },
            "disabled": false,
            "multiple": false,
            "list-type": "text",
            "__config__": {
              "tag": "el-upload",
              "_tag": "a-upload",
              "span": 24,
              "label": "附件上传",
              "formId": "kgmTgiCZ2",
              "layout": "colFormItem",
              "regList": [],
              "tagIcon": "upload",
              "document": "https://element.eleme.cn/#/zh-CN/component/upload",
              "fileSize": 5,
              "required": false,
              "showItem": true,
              "sizeUnit": "MB",
              "changeTag": true,
              "renderKey": "kgmTgiCZ21657508249951",
              "showLabel": true,
              "buttonText": "点击上传",
              "notify": '提示： 需上传房主身份证照片、房产证照片、水表正面照片（有水卡水表需要插卡拍照）、水表侧面照片（包含水表号）',
              "renderItem": true
            },
            "__vModel__": "houseCertificate",
            "buttonText": "",
            "auto-upload": true,
            "placeholder": "请上传附件文件",
            "__readonly__": {
              "span": 2
            },
            "uploadNumber": 5
          }
        ],
        "document": "https://element.eleme.cn/#/zh-CN/component/layout#row-attributes",
        "renderKey": "kM1lzLIcv1637827546906",
        "layoutTree": true,
        "componentName": "row_kM1lzLIcv"
      }
    }
  ],
  "gutter": 15,
  "formRef": "elForm",
  "disabled": false,
  "formBtns": true,
  "readonly": false,
  "formModel": "formData",
  "formRules": "rules",
  "labelWidth": 100,
  "labelPosition": "right"
}

export { renamedFormData, phoneFormData };